import React from "react";

export default () => {
  return (
    <svg
      t="1677138871761"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="6331"
    >
      <path
        d="M782.6 104.4H235.2c-35.3 0-64 28.7-64 64v688c0 35.3 28.7 64 64 64h547.4c35.3 0 64-28.7 64-64v-688c0-35.4-28.6-64-64-64zM247.7 147h520.1c17.7 0 32 14.3 32 32v496H215.7V179c0-17.7 14.3-32 32-32z m520.1 729.7H247.7c-17.7 0-32-14.3-32-32V717.6h584.1v127.1c0 17.7-14.3 32-32 32z"
        p-id="6332"
      ></path>
      <path
        d="M387.9 258.6h228.9c11.8 0 21.3-9.5 21.3-21.3s-9.5-21.3-21.3-21.3H387.9c-11.8 0-21.3 9.5-21.3 21.3s9.5 21.3 21.3 21.3zM562 771.9H442.7c-11.8 0-21.3 9.5-21.3 21.3s9.5 21.3 21.3 21.3H562c11.8 0 21.3-9.5 21.3-21.3 0-11.7-9.5-21.3-21.3-21.3z"
        p-id="6333"
      ></path>
    </svg>
  );
};
